<template>
  <div id="app">
    <template v-if="configData">
      <Header
        :configData="configData"
        :section_list="section_list"
        :scrollPosition="scrollPosition"
        :user="user"
        :logged="logged"
        :id_search_category="id_search_category"
        :id_search_subcategory="id_search_subcategory"
        :search_subcategory="search_subcategory"
      />
      <CartSidebar />
      <main>
        <router-view />
      </main>
      <LoginModal />
      <MarketingModal />
      <WhatsappManagerPopUp />
      <GodaddyPopUp />
      <WhatsappWidget :configData="configData" />
      <GodaddyWidget :configData="configData" />
      <ToTopButton />
      <template v-if="configData.designFlags.isRedesignFooter">
        <RedesignFooter :configData="configData" :section_list="section_list" />
      </template>
      <template v-else>
        <Footer :configData="configData" :section_list="section_list" />
      </template>
      <WhatsappSessionMobile />
    </template>
  </div>
</template>

<script>
import {
  generateRefreshTokenBodyRequest,
  setTokens,
  getAccessToken,
} from '@/helpers/localStorage.helpers';
import { UNAUTHORIZED } from '@/types/httpd.constants';
import WhatsappWidget from '@/components/widgets/WhatsappWidget';
import GodaddyWidget from '@/components/widgets/GodaddyWidget';
import ToTopButton from '@/components/widgets/ToTopButton';
import WhatsappSessionMobile from '@/components/widgets/WhatsappSessionMobile';
import Header from '@/components/general/Header/Header';
import Footer from '@/components/general/Footer/Footer';
import RedesignFooter from '@/components/general/RedesignFooter/RedesignFooter';
import CartSidebar from '@/components/general/Cart/CartSidebar';
import LoginModal from '@/components/general/Modals/LoginModal';
import WhatsappManagerPopUp from '@/components/general/Modals/WhatsappManagerPopUp';
import GodaddyPopUp from '@/components/general/Modals/GodaddyPopUp';
import MarketingModal from '@/components/general/Modals/MarketingModal';
import { getSections } from '@/service/sections.service';
import { postLogin, getProfileData } from '@/service/account.service';

export default {
  components: {
    WhatsappWidget,
    ToTopButton,
    WhatsappSessionMobile,
    Header,
    Footer,
    RedesignFooter,
    CartSidebar,
    LoginModal,
    WhatsappManagerPopUp,
    GodaddyWidget,
    GodaddyPopUp,
    MarketingModal,
  },
  props: ['configData', 'section_list'],
  metaInfo: {
    title: 'Inicio',
    titleTemplate: '%s',
  },
  data() {
    return {
      logged: false,
      user: new Object(),
      scrollPosition: null,
      id_search_category: 0,
      id_search_subcategory: 0,
      search_subcategory: 'Todas las categorías',
    };
  },
  watch: {
    $route() {
      $('#navbar1').collapse('hide');
      $('#navbar2').collapse('hide');
    },
  },

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    callUserInformation() {
      getProfileData(getAccessToken())
        .then((response) => {
          this.user = response.data;
          this.logged = true;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.callUserInformation();
              })
              .catch((_) => {
                this.logged = false;
              });
          }
          this.logged = false;
        });
    },

    setSearch_category(value) {
      this.search_subcategory = value.product_type_desc_es;
      this.id_search_subcategory = 0;
      this.c = value.id_category;
      this.$router.push('/productos/0/1/' + value.id_category + '/0/0/0');
    },

    setSearch_subcategory_toSeccion(subcategory_id, subcategory_description, section) {
      this.search_subcategory = subcategory_description;
      this.id_search_category = 0;
      this.id_search_subcategory = subcategory_id;
      this.$router.push({ name: section });
    },

    setSearch_subcategory(subcategory_id, subcategory_description, idcategoria) {
      this.search_subcategory = subcategory_description;
      this.id_search_category = idcategoria;
      this.id_search_subcategory = subcategory_id;
      if (idcategoria == 0) {
        this.$router.push({ name: 'productos' });
      } else {
        this.$router.push(
          '/productos/0/1/' + idcategoria + '/' + this.id_search_subcategory + '/0/0',
        );
      }
    },
  },

  created() {
    this.callUserInformation();
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Titillium+Web');
@import 'assets/css/colors.css';
@import 'assets/css/new.css';
@import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
@import 'assets/css/ec.css';
@import 'assets/css/personalized_style.css';
@import 'assets/css/simple-sidebar.css';
</style>
